import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { updateEditAction } from '@/main/store/actionsFunctions';
import { generateDependentTableFilters } from '@/main/utils/dependentTablesGenerator';

import { mergeActions } from './types';
import { VOZIDLO_MERGE as name, DEPENDENT_TABLES as depTableNames, CRUMB_LABEL_KEY, MERGE, VOZIDLO_MERGE_VALUES } from '../constants';
import { apiProvider } from '../api';
import { edit, dropdownList } from './edit';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames,
	depTableSettings: {
		[MERGE]: {
			filter(state) {
				return {
					...(state.edit.VozidloId && { CilId: state.edit.VozidloId }),
					ZdrojId: state.props.kontaktId,
				};
			},
		},
		[VOZIDLO_MERGE_VALUES]: {
			filter(state) {
				return {
					CilId: state.edit.VozidloId,
				};
			},
		},
	},
	localState: {},
	extraActions: {
		[mergeActions.GET_VOZIDLO]: ({ commit, state, dispatch }, id) => updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.getVozidlo(id),
		),
	},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		kontaktId: null as number | null,
		fromVinSpzExit: false as boolean,
	},
});
